'use strict';

namespace TR {
    export class AnalyticsTracker {
        private isTrackingCounted = false;

        isEnabled() {
            return TRPCONFIG.Domain.EnableAnalyticsTracking;
        }

        isCounted() {
            return this.isTrackingCounted;
        }

        resetStatus(status) {
            this.isTrackingCounted = status;
        }
    }

    angular
        .module('TR')
        .service('analyticsTracker', AnalyticsTracker);
}
